import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import RepVisitsNotificationsHSAvailableComponent from './notifications-hsavailable';
import { loadMorePaginationProp, SimpleLoadingComponent } from '../../utils/apollo';
import { PUBLISHED_AVAILABILITY, PUBLISHED_FAIR } from '../../components/NotableEvent/constants';

export const RepVisitsEventsQuery = gql`
  query RepVisitsNotableEvents($first: Int!, $types: [RepVisitsNotableEventType], $after: String) {
    viewer {
      id
      repVisitsNotableEvents(first: $first, types: $types, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            eventType
            timestamp
            highSchool {
              id
              name
            }
          }
        }
      }
    }
  }
`;

const graphqlData = graphql(RepVisitsEventsQuery, {
  options: () => ({
    variables: {
      first: 25,
      types: [PUBLISHED_AVAILABILITY, PUBLISHED_FAIR],
    },
  }),
  props: loadMorePaginationProp(RepVisitsEventsQuery),
});

export default SimpleLoadingComponent(graphqlData)(RepVisitsNotificationsHSAvailableComponent);
